/**
 * Created by StoneWang on 2020/11/30.
 */
import React from 'react';
import Reflux from 'reflux';
import {
  hashHistory,
  withRouter,
} from 'react-router';
import {
  Input,
  Modal,
} from 'antd';
import {
  TableView,
} from '../../components';
import { categoryTree } from '../../service/category';
import { getProductListPcForCommodity } from '../../service/merchandise';
import moment from 'moment';
import { openNotice, unique } from 'Utils';

const Search = Input.Search;

class ProductList extends Reflux.Component {
  constructor(props) {
    super(props);
    this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
    this.state = {
      visible: false,
      loading: false,
      selectedProducts: [], // 选择的产品
      selectedRowKeys: [], // 选择的产品 id
      catrgoryTree: [],
      channelCode: this.channelData.split('|')[1] || '',
      searchObj: {
        name: '', /*物料名称 筛选*/
        channelCode: this.channelData.split('|')[1] || '',
        shellFrame: '', /*壳架 筛选*/
        proBigType: '', /*物料大类 筛选*/
        proMiddleType: '', /*物料中类 筛选*/
        proDetailType: '', /*物料中类 筛选*/
        categoryShow: [], // 控制产品分类展示效果
        proDetailName: '',
        stockType: '', /*库存类型 筛选*/
        createTimeStart: '', // 起
        createTimeEnd: '', // 止
        s: 10,
        p: 1,
      },
      rows: [],
      total: 0,
    };
    this.pageChange = this.pageChange.bind(this);
    this.getCategory = this.getCategory.bind(this);
    this.getData = this.getData.bind(this);
    this.onSearchHandle = this.onSearchHandle.bind(this);
  };

  componentWillReceiveProps(newProps) {
    if (newProps.visible !== this.state.visible) {
      this.setState({
        visible: newProps.visible,
        searchObj: {
          ...this.state.searchObj,
          ...newProps.params,
        },
      }, () => {
        if (this.state.visible) {
          this.getData();
        }
      });
    }
  }

  componentDidMount() {
  }

  //获取分类
  getCategory() {
    categoryTree({ id: 1 }).then(result => {
      if (result.status) {
        const filterEmpty = (list) => list.map(x => {
          let key = x.code; // 实际使用的业务数据是 code；
          if (x.children && x.children.length) {
            return {
              ...x,
              key: key, // 使用实际业务数据重新给 key 赋值
              value: key, // 使用实际业务数据重新给 value 赋值
              isLeaf: false,
              children: filterEmpty(x.children),
            };
          }
          return {
            ...x,
            key: key,
            value: key,
            isLeaf: true,
            children: undefined,
          };
        });
        this.setState({
          categoryTree: filterEmpty(result.data || []),
        });
      } else {
        openNotice('error', result.message);
      }
    });
  }

  goView(url) {
    hashHistory.push(url);
  };

  onSearchHandle(val) {
    this.setState({
      searchObj: {
        ...this.state.searchObj,
        name: val,
        p: 1,
      },
    }, () => {
      this.getData();
    });
  }

  pageChange(page, pageSize) {
    this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, () => {
      this.getData();
    });
  }

  getData() {
    let self = this;
    let searchObj = self.state.searchObj;
    self.setState({ loading: true });
    getProductListPcForCommodity(searchObj).then(function (result) {
      if (result && result.code == 200) {
        /*var catrgoryTree = self.state.catrgoryTree;
         var proBigName = '';*/
        result.data.forEach((item, i) => {
          if (item.showPriceDate) {
            result.data[i].showPriceDate = moment(result.data[i].showPriceDate).format('YYYY-MM-DD');
          }
        });
        self.setState({
          'rows': result.data || [],
          'total': result.total,
          'loading': false,
        });
      } else {
        openNotice('error', '数据获取失败', '');
        self.setState({ 'loading': false });
      }
    });
  }

  onSelectChange = (selectedRowKeys, selectedRows) => {
    const { selectedProducts } = this.state
    let list = unique(selectedProducts.concat(selectedRows), 'id');
    this.setState({
      selectedRowKeys,
      selectedProducts: list
    })
  };

  onOkHandle = () => {
    this.props.onOk(this.state.selectedProducts);
  };

  render() {
    const { visible, rows, total, searchObj, selectedRowKeys, loading } = this.state;
    const tableViewProps = {
      loading: loading,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange,
      },
      columns: [
        {
          title: '物料名称',
          dataIndex: 'name',
          width: 200,
          render: (text, record, index) => <a href={`#/product/${record.id}`}
                                              style={{ whiteSpace: 'pre-wrap' }}>{text}</a>,
        },
        {
          title: '物料类别编码',
          dataIndex: 'proBigCode',
          render: (text, record, index) => {
            return record.proBigType + '.' + record.proMiddleType + '.' + record.proDetailType;
          },
        },
        {
          title: '物料类别',
          dataIndex: 'proBigName',
          render: (text, record, index) => {
            return record.proBigName + '.' + record.proMiddleName + '.' + record.proDetailName;
          },
        },
        {
          title: '物料编码',
          dataIndex: 'itemNum',
          width: 120,
        }, {
          title: '单位',
          dataIndex: 'unit',
        },
        {
          title: '库存类型',
          dataIndex: 'stockType',
        },
        {
          title: '最小装箱数',
          dataIndex: 'minOrderQuantity',
        },
        {
          title: '最小起订量',
          dataIndex: 'minPackageQuantity',
        },
        {
          title: '装箱数',
          dataIndex: 'packageQuantity',
        },
        {
          title: '产品线',
          dataIndex: 'proLine',
          render: (text, record, index) => {
            if (text === '01') return '元器件';
            if (text === '02') return '电工';
            if (text === '03') return '电表';
            if (text === '04') return '变频器';
            if (text === '05') return '天e';
            if (text === '06') return 'TG精品';
            return '';
          },
        },
        {
          title: '壳架',
          dataIndex: 'shellFrame',
        },
        {
          title: '牌价',
          dataIndex: 'showPrice',
          render: text => <span style={{ color: '#d61518' }}>{'¥' + text}</span>,
        },
        {
          title: '价格起始日期',
          dataIndex: 'showPriceDate',
        },
      ],
      rows,
      rowSelection: {
        selectedRowKeys,
        onChange: this.onSelectChange,
      },
    };
    const modalProps = {
      width: this.props.width || 1000,
      visible: visible,
      title: '选择关联产品',
      onOk: () => this.onOkHandle(),
      onCancel: this.props.onCancel,
    };
    return <Modal {...modalProps}>
      <Search
        placeholder="输入物料名称/编号"
        style={{ width: 200 }}
        value={searchObj.name}
        onChange={e => this.setState({
          searchObj: {
            ...this.state.searchObj,
            name: e.target.value,
          },
        })}
        onSearch={value => this.onSearchHandle(value)}
      />
      <div className="dms-table-box">
        <TableView {...tableViewProps} />
      </div>
    </Modal>;
  }
}
;
export default withRouter(ProductList);



// WEBPACK FOOTER //
// ./src/routes/merchandise/productModal.js